import React, { useContext, useEffect, useState } from "react";
import Banner from "../Banner";
import "./Header.css";
import shareButton from "../../assests/popup/shareButton.svg";
import user from "../../assests/user.svg";
import moment from "moment";
import { useUserAuth } from "../../context/UserAuthContext";
import { useLocation, useNavigate, useParams } from "react-router";
import SharePopup from "../SharePopup/SharePopup";
import back from "../../assests/backButtonNew.svg";
import Context from "../../context/Context";
import { isEmpty } from "lodash";
import { createSearchParams } from "react-router-dom";

function SignupPageHeader({ themeImage, landing, setLanding }) {
  const {
    currentUser,
    setPreviousLocation,
    previousLocation,
    otpShow,
    setOtpShow,
    enterUserDisplayName,
    setEnterUserDisplayName,
    searchParams,
  } = useUserAuth();
  const location = useLocation();
  var coverStyle = {
    background: "#0B0B0B",
    // "linear-gradient(180deg, #FCFF4B -11.56%, #E788FF 39.16%, #FF8989 87.54%)",
  };
  var themeBackground = {
    background: `url(${themeImage}) center center / cover`,
  };

  const campaignUniqueTextFromLocal =
    localStorage.getItem("campaignUniqueText");
  const orgUniqueTextFromLocal = localStorage.getItem("organizerUniqueText");
  const navigate = useNavigate();
  const { preview, isMobile } = useContext(Context);
  const handleNavigateToPrevLocation = () => {
    let previousState = location?.state?.previousLocation;
    if (otpShow && !enterUserDisplayName?.display) {
      setOtpShow(false);
    } else if (enterUserDisplayName?.display) {
      setOtpShow(false);
      setEnterUserDisplayName({ ...enterUserDisplayName, display: false });
    } else if (landing == false) {
      setLanding(true);
    } else {
      if (previousLocation) {
        navigate(previousLocation);
      } else if (previousState) {
        navigate({
          pathname: previousState,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      } else if (orgUniqueTextFromLocal && campaignUniqueTextFromLocal) {
        navigate({
          pathname: `/${orgUniqueTextFromLocal}/${campaignUniqueTextFromLocal}`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      } else {
        navigate({
          pathname: `/`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      }
    }
  };
  return (
    <>
      <div
        className="h-[465px] relative min-h-[167px] max-h-[465px] w-[100%] bg-white cover-top fixedPos"
        style={themeImage ? themeBackground : coverStyle}
      >
        <div className="cover-top-shade absolute top-[0] z-0"></div>

        <div className=" flex items-center justify-between w-[100%] p-[20px] z-10 sticky top-0">
          {otpShow || enterUserDisplayName?.display ? (
            <img
              src={back}
              alt=""
              className="w-[40px] h-[40px] hover:cursor-pointer dismissButton z-[1]"
              onClick={handleNavigateToPrevLocation}
            />
          ) : (
            !isMobile && (
              <img
                src={back}
                alt=""
                className="w-[40px] h-[40px] hover:cursor-pointer dismissButton z-[1]"
                onClick={handleNavigateToPrevLocation}
              />
            )
          )}
        </div>

        <div className="cover-bottom-shade absolute bottom-[0] z-0"></div>
      </div>
    </>
  );
}

export default SignupPageHeader;
